// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  castToFloat,
  roundToFixed,
} from 'helpers/reduxFormFunctions'

import {
  precisionFt,
  precisionM,
} from 'config/constants'

// NOTE - this expects that e.target.value is a string

export const formatElevationOnBlur = (e, inputOnBlur, unitType) => {
  // get the value from the input
  const v = e.target.value.replace(/,/g, '')

  // determine what degree of precision you need
  const p = unitType === 'SI' ? precisionM : precisionFt

  // if the value is a 'number' then round it
  // else just return the value as is from the input
  const f = (
    v.length > 0 &&
    castToFloat(v) !== null
      ? roundToFixed(v, p)
      : v
  )

  return inputOnBlur(f.toString())
}
